import { render } from "./TaskItem.vue?vue&type=template&id=6040c172&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"

import "./TaskItem.vue?vue&type=style&index=0&id=6040c172&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6040c172"]])

export default __exports__